import { render, staticRenderFns } from "./GiveFeedBack.vue?vue&type=template&id=dc1ea798&"
import script from "./GiveFeedBack.vue?vue&type=script&lang=js&"
export * from "./GiveFeedBack.vue?vue&type=script&lang=js&"
import style0 from "./GiveFeedBack.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports